/* global dataLayer, _cc10461, Sailthru */
function initialize () {
  gtmTitle();
}

function gtmTitle() {
  if (document.title.indexOf(" - Axios") > 0) {
    const slicedTitle = document.title.slice(0, document.title.indexOf(" - Axios"));
    dataLayer.push({ title: slicedTitle });
  }
}

function setUser(id) {
  dataLayer.push({ "userID Data Layer Var": id });
}

function setStream (stream) {
  dataLayer.push({ "Stream": stream });
}

function pageView() {
  dataLayer.push({
    "Card": false,
    "event": "GA_Virtual_Pageviews_Event",
  });
}

function storyPageView(story, stream) {
  dataLayer.push({
    "Headline": story.headline,
    "Stream": stream,
    "Authors": story.authors && story.authors.map((author) => author.display_name).join("|"),
    "Primary Section": story.primary_section && story.primary_section.name,
    "Sections": story.sections && story.sections.map((section) => section.name).join("|"),
    "Primary Tag": story.primary_tag && story.primary_tag.name,
    "Tags": story.tags && story.tags.map((tag) => tag.name).join("|"),
    "Post ID": story.id,
    "Card": true,
    "Rubric": story.rubric && story.rubric.name,
    "event": "GA_Virtual_Pageviews_Event",
  });
}

/*
  This event should be triggered if a post is still in view 3 seconds
  after it was initially registered in the viewport
 */
function userScrollsStoryIntoView(data) {
  const { story, stream } = data;

  storyPageView(story, stream);

  // Lotame
  const sectionTags = story.sections.concat(story.primary_section || []).map((s) => s.slug)
    .concat(story.tags.concat(story.primary_tag || []).map((t) => t.name));
  let postAttributes = sectionTags.join().replace(/ /g,"_");
  typeof _cc10461 !== "undefined" && _cc10461.bcpw("int",postAttributes,"act",postAttributes);

  // Sailthru
  typeof Sailthru !== "undefined" && Sailthru.track("pageview", {
    url: story.permalink,
  });
}

const isStoryInView = (card) => {
  // In view story is one where top is above top of page and bottom is still in view
  const bounds = card.getBoundingClientRect();
  return bounds.top < 60 && bounds.bottom > 60;
};

export default {
  initialize,
  gtmTitle,
  setUser,
  setStream,
  pageView,
  storyPageView,
  userScrollsStoryIntoView,
  isStoryInView,
};
